export const apiRoutes = {
  getUserConfig: () => `getUserConfig`,

  getOrders: (searchParams?: URLSearchParams) => {
    const query = searchParams ? new URLSearchParams(searchParams).toString() : ''
    return `orders?enableOptimization=${!!searchParams}${query ? '&' + query : ''}`
  },

  initiatePayment: (orderKey: string, notificationId: string, search: string) =>
    `order/${orderKey}/notification/${notificationId}/initiatePayment${search}`,

  initiatePayloadPayment: (orderKey: string, notificationId: string, search: string) =>
    `order/${orderKey}/notification/${notificationId}/payload/initiatePayloadPayment${search}`,

  submitPayloadPayment: (orderKey: string, notificationId: string, search: string) =>
    `order/${orderKey}/notification/${notificationId}/payload/submitPayloadPayment${search}`,

  getPayloadMetaData: (orderKey: string, notificationId: string, search: string) =>
    `order/${orderKey}/notification/${notificationId}/payload/getPayloadMetaData${search}`,

  paymentSubmit: (orderKey: string, notificationId: string, search: string) =>
    `order/${orderKey}/notification/${notificationId}/submittedPayment${search}`,

  submitAccountVerification: (orderKey: string, notificationKey: string, search: string) =>
    `order/${orderKey}/notification/${notificationKey}/submitAccountVerification${search}`,

  createAccessToken: (orderKey: string, notificationId: string, search: string) =>
    `order/${orderKey}/notification/${notificationId}/plaid/getAccessToken${search}`,

  declinePlaid: (orderKey: string, notificationId: string, search: string) =>
    `order/${orderKey}/notification/${notificationId}/plaid/decline${search}`,

  getOrder: (orderKey: string, search: string) =>
    `order/${orderKey}${search}`,

  getNotification: (orderKey: string, notificationId: string, search: string) =>
    `order/${orderKey}/notification/${notificationId}${search}`,

  getNotificationStatusesV2: (orderKey: string, notificationKey: string, search: string) =>
    `order/${orderKey}/notification/${notificationKey}/eventStatuses${search}`,

  getUploads: (companyIdOrderIdHash: string, search: string) =>
    `order/${companyIdOrderIdHash}/uploads${search}`,

  createLinkToken: (orderKey: string, notificationId: string, search: string) =>
    `order/${orderKey}/notification/${notificationId}/plaid/getLinkToken${search}`,

  getOrderNotifications: (orderKey: string, search: string) =>
    `order/${orderKey}/notifications${search}`,

  userResetTask: (orderKey: string, notificationId: string, search: string) =>
    `order/${orderKey}/notification/${notificationId}/userReset${search}`,

  userCancelTask: (orderKey: string, notificationId: string, search: string) =>
    `order/${orderKey}/notification/${notificationId}/userCancel${search}`,

  userCompleteTask: (orderKey: string, notificationId: string, search: string) =>
    `order/${orderKey}/notification/${notificationId}/userComplete${search}`,

  communicationPreference: (search: string) =>
    `communicationPreference${search}`,

  formRetrieve: (orderKey: string, notificationId: string, formKey: string, search: string) =>
    `order/${orderKey}/notification/${notificationId}/form/${formKey}/retrieve${search}`,
  
  bankInformation: (orderKey: string, notificationId: string, routingNumber: string, search: string) =>
    `order/${orderKey}/notification/${notificationId}/bankInformation/${routingNumber}${search}`,

  getCustomFields: (orderKey: string, search: string) =>
    `order/${orderKey}/getCustomFields${search}`,
}
